import React, { useMemo, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './characters-count.styles.js'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const CharactersCount = ({ classes, value, max, className, ...props }) => {
  const charactersLeft = useMemo(() => max - value.length, [max, value])
  return (
    <span className={classNames(classes.counter, className)} {...props}>
      {charactersLeft >= 0 && (
        <Fragment>
          {charactersLeft}/{max} characters left
        </Fragment>
      )}
      {charactersLeft < 0 && (
        <span className={classes.error}>
          {Math.abs(charactersLeft)} characters to remove
        </span>
      )}
    </span>
  )
}

CharactersCount.propTypes = {
  /** String value */
  value: PropTypes.string.isRequired,
  /** Limit number */
  max: PropTypes.number.isRequired,
  /** Additional className if you want to restyle component */
  className: PropTypes.string
}

export default injectSheet(styles)(CharactersCount)
